import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

const BASE_URL = "https://dev.sutmmg.codydeasoftech.in/api";

const JobWrorkerList = () => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ item_id: "" });
  const [rateList, setRateList] = useState([]);
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
      const [totalRecords, setTotalRecords] = useState(0);
      const [totalPages, setTotalPages] = useState(1);


      const theadStyle = {

                  padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",

  }

const fetchItems = async () => {
  setLoading(true);
  try {
const token = localStorage.getItem("token");

    const res = await axios.post(`${BASE_URL}/itemsList`,{},
     {

      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

const filteredItems =
      res.data?.data?.itemsList?.filter(
        (item) => Number(item.status) !== 0
      ) || [];

    setItems(filteredItems);  } catch (error) {
    console.error("Fetch Items Error:", error);



  }
};
  // 🔹 OPTIONAL: static dropdown (replace later if needed)


  const getPageNumbers = () => {
  const pages = [];
  const maxPagesToShow = 5;

  let start = Math.max(1, page - 2);
  let end = Math.min(totalPages, start + maxPagesToShow - 1);

  if (end - start < maxPagesToShow - 1) {
    start = Math.max(1, end - maxPagesToShow + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages;
};

  // 🔥 FETCH API
  const fetchJobWorkerRates = async (page = 1,searchValue= filters.item_id) => {
    try {
      setLoading(true);
  const token = localStorage.getItem("token");

      const payload = {
        item_id: searchValue || "",
        page,
        per_page: perPage,
      };

      const res = await axios.post(
        `${BASE_URL}/jobWorkerRateList`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setRateList(res.data?.data || []);
      setPage(res.data.page || 1);
    setTotalRecords(res.data.total_records || 0);
    setTotalPages(
      Math.ceil(
        (res.data.total_records || 0) /
        (res.data.per_page || perPage)
      )
    );
    } catch (err) {
      console.error("Job Worker Rate List Error", err);
    } finally {
      setLoading(false);
    }
  };

  // 🔁 LOAD ON PAGE OPEN
  useEffect(() => {

    fetchItems();
  }, []);

      useEffect(() => { fetchJobWorkerRates(1); }, [perPage]);


  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* 🔷 Header */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div
          className="px-4 py-3 text-white rounded-top"
          style={{
            background: "linear-gradient(90deg, #0D47A1, #1565C1)",
          }}
        >
          <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
            <i className="fa-solid fa-filter"></i> Job Worker Rate List
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            {/* Item Dropdown */}
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>Item</Form.Label>
                <Form.Select
  value={filters.item_id}
  onChange={(e) =>
    setFilters({ ...filters, item_id: e.target.value })
  }
  style={{
    borderRadius: "10px",
    border: "2px solid #1565C1",
  }}
>
  <option value="">All Items</option>

  {items.map((item) => (
    <option key={item.id} value={item.id}>
      {item.item_name}
    </option>
  ))}
</Form.Select>

              </Form.Group>
            </Col>

            <Col md={3}>
                  <Form.Group className="mb-3">
                                  <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>

                      <Form.Select
                       style={{
                                      borderRadius: "10px",
                                      border: "2px solid #1565C1",
                                    }}
                        value={perPage}
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          setPerPage(value);
                          setPage(1);

                        }}

                      >
                        <option value={10}>10 Per Page</option>
                              <option value={25}>25 Per Page</option>
                              <option value={50}>50 Per Page</option>
                              <option value={100}>100 Per Page</option>
                      </Form.Select>
                      </Form.Group>
                  </Col>

                  {/* ✅ BUTTONS */}
                  <Col md={4} className="d-flex gap-3 mt-3">
                    {/* SEARCH */}
                    <Button
                      className="w-50 fw-semibold text-white"
                      style={{
                        background: "#1565C1",
                        border: "none",
                        borderRadius: "10px",
                        transition: "0.3s",
                      }}
                      onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                      onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                      onClick={() => fetchJobWorkerRates(1, filters.item_id)}
                    >
                      <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                    </Button>

                    {/* RESET */}
                    <Button
  className="w-50 fw-semibold text-white"
  style={{
    background: "#E53935",
    border: "none",
    borderRadius: "10px",
    transition: "0.3s",
  }}
  onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
  onMouseLeave={(e) => (e.target.style.background = "#E53935")}
  onClick={() => {
    setFilters({ item_id: "" });   // ✅ reset the correct filter
    setPage(1);
    setPerPage(10);
    fetchJobWorkerRates(1, "");    // ✅ fetch fresh data after reset
  }}
>
  <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
</Button>

                  </Col>
          </Row>
        </Card.Body>
      </Card>

{loading && (
        <div className="loader-wrapper">
            <div className="blue-spinner"></div>

            <div className="loading-line">
            <div className="loading-progress"></div>
            </div>

            <p className="loading-text">Loading, please wait...</p>
        </div>
        )}
      {!loading && (
        <>
        {/* 📄 TABLE */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
          boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
          overflow: "hidden",
        }}
      >
        <Table bordered hover responsive striped>
          <thead>
            <tr>
              <th style={theadStyle}>SL No.</th>
              <th style={theadStyle}>Item Name</th>
              <th style={theadStyle}>Job</th>
              <th style={theadStyle}>Rate</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="3" className="text-center py-4">
                  Loading...
                </td>
              </tr>
            ) : rateList.length > 0 ? (
              rateList.map((row, index) => (
                <tr key={row.id}>
<td className="text-center">
          {(page - 1) * perPage + index + 1}
        </td>                  <td className="text-center">{row.item_name}</td>
                                    <td className="text-center">{row.action_name}</td>

                  <td className="text-center">₹{row.price}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center text-muted py-4">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>


      </Card>

       {
    totalPages > 1 && (
         <div className="d-flex justify-content-center mt-4">
        <nav>
            <ul className="pagination shadow-sm">

            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchJobWorkerRates(1)}>
                «
                </button>
            </li>

            {/* Prev */}
            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchJobWorkerRates(page - 1)}>
                ‹
                </button>
            </li>

            {/* Page Numbers */}
            {getPageNumbers().map((p) => (
                <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                <button className="page-link" onClick={() => fetchJobWorkerRates(p)}>
                    {p}
                </button>
                </li>
            ))}

            {/* Next */}
            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchJobWorkerRates(page + 1)}>
                ›
                </button>
            </li>

            {/* Last */}
            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchJobWorkerRates(totalPages)}>
                »
                </button>
            </li>

            </ul>
        </nav>
    </div>
    )}
        </>
      )

      }
    </div>
  );
};

export default JobWrorkerList;
